__turbopack_context__.v({
  "primaryButton": "submitButton-module__6HBxWW__primaryButton",
});
